{
  "name": "sites-builder-app",
  "version": "1.10.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --configuration development --ssl",
    "dev:mobile": "ng serve --host 0.0.0.0 --allowed-hosts local.3ddigitalvenue.com --public-host local.3ddigitalvenue.com --configuration development",
    "start": "ng serve --host local.3ddigitalvenue.com --open --ssl true",
    "start:local": "ng serve --host local.3ddigitalvenue.com --configuration local --open --ssl true",
    "start:prod": "ng serve --host local.3ddigitalvenue.com --configuration production --open --ssl true",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:pre": "ng build --configuration preproduction",
    "build:prod": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:coverage": "ng test --coverage",
    "lint": "ng lint",
    "gate:plan": "node tools/harness/run.mjs plan",
    "gate:changed": "node tools/harness/run.mjs changed",
    "gate:profile": "node tools/harness/run.mjs profile",
    "gate:full": "node tools/harness/run.mjs full",
    "gate:harness": "node tools/harness/run.mjs harness",
    "agent:preflight": "node tools/harness/preflight-codex.mjs",
    "clean:workspace": "node tools/clean-workspace.mjs"
  },
  "private": true,
  "dependencies": {
    "@3ddv/dvm-internal": "^2.8.0",
    "@3ddv/ngx-dvm-internal": "^5.0.0",
    "@angular/animations": "^21.2.24",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.24",
    "@angular/compiler": "^21.2.24",
    "@angular/core": "^21.2.24",
    "@angular/forms": "^21.2.24",
    "@angular/platform-browser": "^21.2.24",
    "@angular/platform-browser-dynamic": "^21.2.24",
    "@angular/router": "^21.2.24",
    "@floating-ui/dom": "^1.6.13",
    "@splidejs/splide": "^4.1.4",
    "@tailwindcss/postcss": "^4.3.3",
    "@tiptap/core": "^3.31.3",
    "@tiptap/extension-heading": "^3.31.3",
    "@tiptap/extension-horizontal-rule": "^3.31.3",
    "@tiptap/extension-link": "^3.31.3",
    "@tiptap/extension-underline": "^3.31.3",
    "@tiptap/starter-kit": "^3.31.3",
    "animejs": "^3.2.2",
    "lodash-es": "^4.17.21",
    "postcss": "8.5.25",
    "rxjs": "~7.8.2",
    "tailwindcss": "^4.0.6",
    "tslib": "^2.3.0",
    "zod": "^3.24.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.24",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "1.61.0",
    "@types/animejs": "^3.1.13",
    "@types/lodash-es": "^4.17.12",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^21.3.1",
    "eslint": "^10.8.0",
    "jsdom": "^29.0.2",
    "schematics": "file:schematics",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.59.0",
    "vitest": "^4.1.11"
  },
  "overrides": {
    "esbuild": "0.28.1",
    "vite": "7.3.5",
    "piscina": "5.3.2"
  }
}
